import React, { useState} from "react";
import {SBL_BuilderPageMain} from "../interfaces";
import {useAppDispatch, useAppSelector} from "../DAL/store";
import EyeIcon from "../../../ui/svg/common/eye";
import {
    IsProductInclude,
    OnProductClickChangeState
} from "../services/logic-helper";
import {LocalEnums, MaxNumberOfChannelInputs} from "../local-enums";

import {cloneDeep} from "lodash";
import ViewProductPopup from "./view-product-popup";
import ProductPriceFormat from "../../products/product-price/product-price-format";

/**
 *  Product Row
 */
interface IProductProps {
    product: SBL_BuilderPageMain,
    onProductClick: (product:any) => void,
    selectedProducts:SBL_BuilderPageMain[],
    isLastRow:boolean
}

const ProductRow = (props:IProductProps) => {

    const [showProductImg, setShowProductImg] = useState(false);
    const UserState_SystemType = useAppSelector((store) => store.UserState_SystemType);
    const UserState_CableCount= useAppSelector((store) => store.UserState_CableCount);
    const UserState_SelectedProducts = useAppSelector((store) => store.UserState_SelectedProducts);
    const ProductList = useAppSelector((store) => store.ProductList);
    const SBL_BuilderPage = useAppSelector((store) => store.SBL_BuilderPage);
    const UserState_NumberOfInputs = useAppSelector((store) => store.UserState_NumberOfInputs);

    const dispatch = useAppDispatch();

    const OnClickRadio = (product:any) => {
        props.onProductClick(product);
        return false;
    }
    const showProductImgPopup = () => {
        setShowProductImg(!showProductImg);
    }
    const UpdateQuantity = async(quantity:number) => {

            let currentProduct = UserState_SelectedProducts.filter(prod => prod.categoryProductID === props.product.categoryProductID);
            //if product is net selected -> do not update it's quantity
            if(currentProduct.length !== 1) return;

            //block action if NumberOfInput is not valid
            //https://wavesaudio.atlassian.net/browse/DSWEB-1021
            //if(props.product.quantity < quantity && UserState_NumberOfInputs + (props.product.numberOfInputs * props.product.quantity) > MaxNumberOfChannelInputs) return;
            //bug-fix props.product.quantity => (quantity -props.product.quantity)
            //console.log('UserState_NumberOfInputs + (props.product.numberOfInputs * (quantity -props.product.quantity))', UserState_NumberOfInputs + (props.product.numberOfInputs * (quantity -props.product.quantity)));
            if(props.product.quantity < quantity
                && UserState_NumberOfInputs + (props.product.numberOfInputs * (quantity -props.product.quantity))
                > MaxNumberOfChannelInputs) return;

            let selectedProducts = cloneDeep(UserState_SelectedProducts);
            selectedProducts.map(prod => {
                if(prod.categoryProductID === props.product.categoryProductID ){
                    prod.quantity = quantity;
                }
                return prod;
            });

            let productList = cloneDeep(ProductList);
            productList.map(prod => {
                if(prod.categoryProductID === props.product.categoryProductID ){
                    prod.quantity = quantity;
                }
                return prod;
            });
            //Activate click product method --> for all hide/show products logic
            OnProductClickChangeState(selectedProducts.filter(prod => prod.categoryID === props.product.categoryID),
                                        props.product.categoryID,
                                        UserState_SystemType,
                                        selectedProducts,
                                        SBL_BuilderPage.sbl_BuilderPageProduct_ProductList,
                                        productList,
                                        SBL_BuilderPage,
                                        dispatch);


    }
    /**
     * WHen product is unChecked --> disable the quantity update
     * */
    const GetIsQuantityDisabled = () => {
        let currentProduct = UserState_SelectedProducts.filter(prod => prod.categoryProductID === props.product.categoryProductID);
        //if product is net selected -> do not update it's quantity
        if(currentProduct.length !== 1) {
            return true;
        }
        return false;

    }
    return (
        <div className="w-full flex items-center justify-center">
            <div className={`cursor-pointer flex items-center justify-center mr-3 md:p-2 md:pb-3 ${props.isLastRow? "":"border-b border-white"}`} onClick={showProductImgPopup}>
                <EyeIcon width={"22px"} color={"#C8C7C7"}/>
            </div>
            <div className={`w-full flex items-center justify-center md:p-2 ${props.isLastRow? "":"border-b"}`}>
                <div className="w-2/3" >
                    <label className="cursor-pointer inline-block flex items-center py-2 py-0 w-fit"
                    >
                        <input
                            type={props.product.selectType === "multi" ? "checkbox":"radio"}
                            name={ props.product.categoryDisplayName }
                            className="mr-4 cursor-pointer"
                            value={ props.product.skuid }
                            checked={ IsProductInclude(props.product,props.selectedProducts) }
                            onClick={() => OnClickRadio(props.product)}
                            onChange={() => {}}
                        />
                        { props.product.skuName }
                        { props.product.numberOfInputs > 0 ? " (" + props.product.numberOfInputs+ " Channel)" : "" }
                    </label>
                </div>
                <div className="w-1/6 text-center">
                    {props.product.maxQuantity > 1 ?
                        <div>
                            {props.product.categoryProductID === LocalEnums.ProductsIds.Cable ?
                                <>{UserState_CableCount}</>
                                :
                                <select
                                    className="border rounded"
                                    value={ props.product.quantity ? props.product.quantity : 1 }
                                    onChange={evt => {
                                        UpdateQuantity(+evt.target.value);
                                    }}
                                    disabled={GetIsQuantityDisabled()}
                                    >
                                    {Array(props.product.maxQuantity).fill(1).map((el, i) =>
                                        <option key={i} value={ i + 1 }>{ i + 1 }</option>
                                    )}

                                </select>
                            }
                        </div>
                        :
                        <div className="h-2 text-white">-</div>
                    }
                </div>
                <div className="w-1/6 text-right font-bold">
                    <ProductPriceFormat price={ props.product.skuPrice } />
                </div>
            </div>
            {showProductImg && <ViewProductPopup product={props.product} closePopup={showProductImgPopup}/>}
        </div>
    );
};

export default ProductRow;
